export default __webpack_public_path__ + "static/media/axie-infinity-planet.40dedf46.png";